import React, {Component} from 'react'

export default class Home extends Component {

    handleButtonDoctorType = (e) => {
        const value = e.target.value.replace(/[^A-zÀ-ÿ0-9_ :(),]+/, '')
        this.props.handleButtonDoctorType(value)
    }

    render() {
        const englishSelected = this.props.englishSelected

        return (
            <main id="main">
                <div id="banner">
                </div>

                {/*The names of the doctors are displayed in the code to avoid the small loading time before they appear*/}
                <div id="centerButtonContainer">
                    <div className="content-button" id="content-button1">
                        <h1>Centre Médical Bonnevoie</h1>
                        <div className="doctorName__container">
                            <span className="doctorName">Dr Amélie Barret-de-Gassart - <span className="italicDoctorName">{englishSelected ? 'General practitioner' : 'Médecin généraliste' }</span></span>
                            <br/>
                            <span className="doctorName">Dr Sarah Weber - <span className="italicDoctorName">{englishSelected ? 'General practitioner' : 'Médecin généraliste' }</span></span>
                            <br/>
                            <span className="doctorName">Dr Sabine Krombach - <span className="italicDoctorName">{englishSelected ? 'Doctor specialist in internal medicine' : 'Médecin spécialiste en médecine interne' }</span></span>
                            <br/>
                            <span className="doctorName">Dr Monique du Reau-de Thezan - <span className="italicDoctorName">{englishSelected ? 'General practitioner' : 'Médecin généraliste' }</span></span>
                            <br/>
                            <span className="doctorName">Dr Nathanael Stricker - <span className="italicDoctorName">{englishSelected ? 'Doctor specialist in internal medicine' : 'Médecin spécialiste en médecine interne' }</span></span>
                        </div>
                        <button value="main" onClick={(e) => this.handleButtonDoctorType(e)} className={`button primary mini centerTypeButton fs-1-5rem`}>{englishSelected ? 'Make an appointment' : 'Prise de RDV' }</button>
                    </div>
                </div>

                <div className="content__background d-flex mb150">

                    <div className="bg-home bg-home-standard"></div>
                    <div className="alt-content">
                    </div>
                </div>

            </main>
        )
    }
}
